<template>
<PageLoader v-if="isLoading"/>
  <HeadWithLogo/>
  <div class="border rounded">
    <div class="row">
      <div class="p-question col-12">
        <div v-for="(question,index) in questions">
          <p class=" px-2 px-md-4 pt-4">
            {{ question.title }}
          </p>
          <br/>
          <div class="px-2 px-md-4">
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="answArr[index]" :name="'q-'+ question.id " value="1">
              <label class="form-check-label-radio" for="exampleRadios1">
                {{ question.a1 }}
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="answArr[index]" :name="'q-'+ question.id " value="2">
              <label class="form-check-label-radio" for="exampleRadios1">
                {{ question.a2 }}
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="answArr[index]" :name="'q-'+ question.id " value="3">
              <label class="form-check-label-radio" for="exampleRadios1">
                {{ question.a3 }}
              </label>
            </div>
            <div class="form-check">
              <input class="form-check-input" type="radio" v-model="answArr[index]" :name="'q-'+ question.id " value="4">
              <label class="form-check-label-radio" for="exampleRadios1">
                {{ question.a4 }}
              </label>
            </div>
            <hr>
          </div>
        </div>

      </div>
    </div>
    <br/>
    <div class="row my-3 mx-1">
      <div class="col-6 text-end">
        <RouterLink to="/rule-tutorial" class="btn btn-success px-3">
          صفحه قبل
        </RouterLink>
      </div>
      <div class="col-6 text-start">
        <button @click="handleExamStep4" class="btn btn-success submit-btn">ثبت</button>
      </div>
    </div>

  </div>
</template>

<script>

import router from '@/router';
import axios from 'axios';
import PageLoader from '../components/Loader';
import HeadWithLogo from "@/components/HeadWithLogo";
export default {
  data(){
    return {
      questions:null,
      quesArr:[],
      answArr:[],
      ansCounter:0,
      isLoading:false,
    }
  },
  components: {
    HeadWithLogo,
    PageLoader,
  },
  mounted(){
    axios
        .get(process.env.VUE_APP_ROOT_API+'/api/getQuestions?api=sfFSadAs1432')
        .then(response => {
          this.questions = response.data
          let counter=0
          this.questions.forEach(element => {
            this.quesArr[counter]=element.id
            this.answArr[counter]=1
            counter+=1
          });
        })

  },
  methods:{
    handleExamStep4(){
      this.isLoading=true
      const headers = {
        accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.token
      }
      axios.get(process.env.VUE_APP_ROOT_API+"/sanctum/csrf-cookie").then(() => {
        axios
            .get(process.env.VUE_APP_ROOT_API+'/api/step4?questions='+this.quesArr+'&answers='+this.answArr, {
              headers: headers
            })
            .then(response => {
              this.isLoading=false
              this.messages = response.data
              if(this.messages.status=="done"){
                alert(this.messages.message)
                localStorage.score=this.messages.score
                if(this.messages.step5 == "1"){
                  router.push('/final')
                }else{
                  router.push("/final-exam-rule")
                }
              }else{
                alert(this.messages.message)
              }

            })
            .catch((err) => {
              this.isLoading=false
              this.errorMessage="خطایی رخ داده است"
            })
      })
    }
  }
}
</script>

<style scoped>
.form-check {
  display: flex;
  justify-content: flex-start;
}

.form-check-label-radio {
  margin-right: 40px;
  font-weight: bold;
}

</style>